<template>
    <v-main class="pt-0">
        <cover-image src="/images/covers/graffiti-cover-desktop.jpg"
                     phone-src="/images/covers/graffiti-cover-phone.jpg"
                     tablet-src="/images/covers/graffiti-cover-tablet.jpg"
                     :opacity="0.2"
                     secondary-color="#ffc947" color="#FF8A2F"
                     :next-section-id="shoots[0].slug"
                     :title="title"
                     subtitle="Model"
                     :description="description"
                     action-text="Let's go!"
                     :action-path="`#${shoots[0].slug}`"
                     full-height main left/>

        <cover-image v-for="shoot in shoots" :key="shoot.slug"
                     :id="shoot.slug"
                     :src="shoot.coverImageDesktop"
                     :tablet-src="shoot.coverImageTablet"
                     :phone-src="shoot.coverImagePhone"
                     :background-color="shoot.coverImageDesktop ? null : shoot.primaryColor"
                     :color="shoot.primaryColor"
                     :secondary-color="shoot.secondaryColor"
                     :title="shoot.title"
                     :subtitle="shoot.date"
                     action-text="Zum Shooting"
                     :action-path="`/photo-shoots/${shoot.slug}`"
                     left>

            <template #description>
                <shoot-artist-list :shoot="shoot"/>
            </template>

        </cover-image>

        <app-footer dark absolute/>

    </v-main>
</template>

<script setup lang="ts">
import {PhotoShootPreview} from "../../types/models/PhotoShoot";

const {data: shoots}: {data: PhotoShootPreview[]} = await useApiFetch('listPhotoShoots', [
    'title',
    'slug',
    'date',
    'primaryColor',
    'secondaryColor',
    'coverImageDesktop',
    'coverImageTablet',
    'coverImagePhone',
    'photographArtist {name url}',
    'makeupArtist {name url}',
    'hairArtist {name url}',
], 'sort: date_DESC');

const title = 'Photo Shoots';
const description = 'Hier findest du meine bisherigen Shootings und die beteiligten Personen. Have fun!';

useMeta({
    title: title,
    description: description,
})

</script>